var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoRplus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 610,
    height: 77,
    viewBox: "0 0 610 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.919 79.2951H423.519C422.642 79.2951 421.832 78.821 421.409 78.0478C420.985 77.2746 421.014 76.3336 421.489 75.5968L431.631 59.746L2.23428 59.695C1.54064 59.695 0.898103 59.3813 0.474613 58.8342C0.0511238 58.2872 -0.094907 57.5869 0.0730285 56.9231L5.1257 37.1698C5.37395 36.185 6.26474 35.4994 7.27965 35.4994H435.07L429.141 19.1234C428.871 18.3939 428.973 17.5697 429.426 16.9277C429.878 16.2785 430.608 15.8992 431.397 15.8992H452.119C453.134 15.8992 454.039 16.5338 454.375 17.4894L465.021 46.6307C465.276 47.3236 465.189 48.1114 464.794 48.7388L445.934 78.2083C445.489 78.9012 444.73 79.317 443.905 79.317L443.919 79.2951ZM7.27965 37.6731L2.19048 57.4556L431.594 57.4994C432.405 57.4994 433.157 57.9443 433.544 58.6519C433.938 59.3667 433.909 60.2348 433.463 60.9204L423.322 76.7712C423.278 76.8442 423.27 76.9171 423.314 76.9974C423.351 77.0703 423.416 77.1068 423.504 77.1068H443.905C443.985 77.1068 444.051 77.0703 444.094 77.0047L462.947 47.5425C462.983 47.4841 462.991 47.4185 462.969 47.3601L452.323 18.2043C452.294 18.1167 452.214 18.0657 452.126 18.0657H431.404C431.317 18.0657 431.258 18.1167 431.229 18.1605C431.2 18.2043 431.171 18.2699 431.207 18.3502L437.173 34.6824C437.421 35.3608 437.319 36.1267 436.902 36.7175C436.486 37.3084 435.807 37.6658 435.077 37.6658H7.27965V37.6731Z",
    fill: "url(#paint0_linear_58_481)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.919 78.4782H423.519C422.935 78.4782 422.416 78.1718 422.131 77.6612C421.847 77.1433 421.869 76.5378 422.182 76.0418L432.324 60.191C432.5 59.9211 432.507 59.6002 432.354 59.3157C432.2 59.0385 431.923 58.8707 431.601 58.8707H2.21971C1.78162 58.8707 1.38004 58.6738 1.10988 58.3309C0.839722 57.9881 0.752103 57.5431 0.861626 57.1201L5.91429 37.3667C6.07493 36.7467 6.62984 36.3091 7.27238 36.3091H435.062C435.347 36.3091 435.603 36.1778 435.763 35.9443C435.924 35.7109 435.961 35.4264 435.866 35.1638L429.9 18.8316C429.718 18.3502 429.791 17.8104 430.083 17.3873C430.382 16.9642 430.864 16.7089 431.382 16.7089H452.104C452.769 16.7089 453.367 17.1247 453.586 17.752L464.232 46.9006C464.4 47.3528 464.342 47.878 464.079 48.2938L445.219 77.7633C444.927 78.2156 444.423 78.4927 443.875 78.4927L443.905 78.4782H443.912H443.919ZM7.27968 36.8561C6.8854 36.8561 6.54953 37.1187 6.44731 37.498L1.39464 57.2514C1.32893 57.5067 1.39464 57.7766 1.54797 57.9881C1.7013 58.1996 1.95686 58.3163 2.22701 58.3163H431.594C432.113 58.3163 432.573 58.5862 432.828 59.0458C433.076 59.5053 433.062 60.0378 432.777 60.4755L422.635 76.3263C422.423 76.6545 422.416 77.0484 422.599 77.384C422.781 77.7195 423.124 77.9238 423.504 77.9238H443.905C444.262 77.9238 444.591 77.7487 444.781 77.4496L463.633 47.9874C463.809 47.7175 463.845 47.3747 463.736 47.0756L453.09 17.9271C452.944 17.5186 452.557 17.2487 452.119 17.2487H431.397C431.054 17.2487 430.747 17.4092 430.55 17.6937C430.353 17.9782 430.309 18.321 430.426 18.6419L436.391 34.9742C436.545 35.4045 436.486 35.886 436.223 36.258C435.96 36.63 435.53 36.8561 435.07 36.8561H7.27968Z",
    fill: "url(#paint1_linear_58_481)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_58_481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M527.544 29.0219C526.704 27.9277 525.258 27.3733 523.243 27.3733H507.136L503.806 39.7009H520.498C524.368 39.7009 526.967 37.6658 528.004 33.8143C528.559 31.7573 528.405 30.1452 527.544 29.0219ZM525.93 33.2599C525.142 36.1923 523.411 37.5564 520.498 37.5564H506.61L508.779 29.5179H523.243C524.141 29.5179 525.324 29.6565 525.835 30.3276C526.375 31.0351 526.186 32.3117 525.93 33.2599ZM548.382 33.807C550.777 24.8714 550.237 18.0656 546.783 13.565C543.439 9.21021 537.357 7 528.697 7H492.204L472.519 80.4184H495.125L500.214 61.4237L514.138 80.4184H542.278L526.317 58.6081C537.401 55.4496 544.819 47.1194 548.382 33.807ZM520.498 37.5564H506.61L508.779 29.5179H523.243C524.141 29.5179 525.324 29.6565 525.835 30.3276C526.375 31.0351 526.186 32.3117 525.93 33.2599C525.142 36.1923 523.411 37.5564 520.498 37.5564Z",
    fill: "url(#paint2_linear_58_481)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M540.57 79.6088H514.43L514.35 79.4993L499.754 59.5928L494.395 79.6088H473.454L492.701 7.80969H528.573C536.97 7.80969 542.84 9.91049 546.024 14.061C549.317 18.3501 549.813 24.9224 547.484 33.6028C543.877 47.061 536.269 55.311 524.849 58.134L540.57 79.6161V79.6088ZM514.7 79.0617H539.511L523.944 57.7838L524.338 57.689C535.765 55.0119 543.373 46.8568 546.966 33.4496C549.244 24.9443 548.791 18.5252 545.6 14.3747C542.519 10.37 536.795 8.33489 528.581 8.33489H493.117L474.155 79.0617H493.979L499.52 58.3601L514.7 79.0617ZM520.374 38.884H504.734L507.632 28.1684H523.126C524.871 28.1684 526.105 28.6207 526.784 29.5033C527.485 30.4151 527.595 31.7938 527.106 33.5955C526.156 37.1041 523.893 38.884 520.374 38.884ZM505.442 38.3442H520.374C523.667 38.3442 525.696 36.7467 526.587 33.4496C527.025 31.8157 526.952 30.5975 526.361 29.8243C525.791 29.0802 524.703 28.7009 523.126 28.7009H508.049L505.442 38.3442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7991 81.6002L72.132 28.1758H53.4108L58.7409 8.26196H116.058L110.728 28.1758H92.0068L77.6738 81.6002H57.7991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.294 81.6002L129.946 59.3011L123.973 81.6002H104.091L123.754 8.26196H160.627C169.104 8.26196 174.996 10.3336 178.136 14.4258C181.392 18.6638 181.852 25.2726 179.494 34.0551C175.77 47.9583 167.892 56.4052 156.07 59.1771L154.997 59.4251L171.214 81.5929H146.286H146.294V81.6002ZM138.649 27.067L134.743 40.7149H151.938C155.757 40.7149 158.4 38.0305 159.437 34.2155C160.466 30.4006 159.663 27.067 155.844 27.067H138.649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.012 81.6002L198.675 8.26196H218.55L198.887 81.6002H179.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.19 81.6002L229.853 8.26196H249.727L235.394 61.6864H256.788L251.458 81.6002H210.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.562 81.6002L310.724 54.888H285.147L277.984 81.6002H258.102L277.765 8.26196H297.647L290.477 34.9742H316.055L323.225 8.26196H343.099L323.436 81.6002H303.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.595 81.6002L385.631 70.9138H354.775L348.086 81.6002H328.416L374.299 8.26196H399.964L406.521 81.6002H386.595ZM381.703 27.7381L363.098 56.4781H383.703L381.703 27.7381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_58_481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.452 59.1041H546.528C545.776 59.1041 545.228 58.382 545.433 57.6598L549.543 42.9615C549.682 42.4728 550.127 42.13 550.639 42.13H566.833C567.344 42.13 567.79 41.7871 567.929 41.2984L572.456 25.1121C572.594 24.6234 573.04 24.2805 573.551 24.2805H588.738C589.49 24.2805 590.038 25.0027 589.833 25.7248L585.649 40.6857C585.445 41.4151 585.993 42.13 586.745 42.13H601.611C602.363 42.13 602.91 42.8521 602.706 43.5743L598.595 58.2726C598.456 58.7613 598.011 59.1041 597.5 59.1041H581.363C580.852 59.1041 580.407 59.447 580.268 59.9357L575.741 76.122C575.602 76.6108 575.157 76.9536 574.646 76.9536H559.459C558.707 76.9536 558.159 76.2314 558.364 75.5093L562.547 60.5484C562.752 59.819 562.204 59.1041 561.452 59.1041Z",
    fill: "url(#paint3_linear_58_481)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M560.233 74.0504L564.416 59.0895C564.621 58.3601 564.073 57.6452 563.321 57.6452H548.397C547.645 57.6452 547.097 56.9231 547.302 56.2009L550.602 44.4058C550.741 43.9171 551.186 43.5743 551.697 43.5743H567.892C568.403 43.5743 568.849 43.2314 568.987 42.7427L573.514 26.5564C573.653 26.0676 574.098 25.7248 574.609 25.7248H586.883C587.635 25.7248 588.183 26.4469 587.979 27.1691L583.795 42.13C583.59 42.8594 584.138 43.5743 584.89 43.5743H599.756C600.508 43.5743 601.056 44.2964 600.851 45.0186L597.551 56.8137C597.412 57.3024 596.967 57.6452 596.456 57.6452H580.319C579.808 57.6452 579.363 57.9881 579.224 58.4768L574.697 74.6631C574.558 75.1519 574.113 75.4947 573.602 75.4947H561.328C560.576 75.4947 560.028 74.7725 560.233 74.0504Z",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_58_481",
    x: 466.519,
    y: 1,
    width: 89.33,
    height: 85.4185,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.352941 0 0 0 0 0.588235 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_58_481"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_58_481",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_58_481",
    x: 539.389,
    y: 18.2805,
    width: 69.3596,
    height: 64.6731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.352941 0 0 0 0 0.588235 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_58_481"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_58_481",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_481",
    x1: 10.193,
    y1: -0.440283,
    x2: 459.642,
    y2: 78.9125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0049",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FF0049",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FF0049",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FF0049",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF0049",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FF0049",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0049"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_58_481",
    x1: 0.817817,
    y1: 47.6008,
    x2: 464.334,
    y2: 47.6008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_58_481",
    x1: 511.188,
    y1: 80.4184,
    x2: 511.188,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_58_481",
    x1: 559.598,
    y1: 50.6134,
    x2: 612.943,
    y2: 50.6134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2121"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 610,
    height: 77,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRplus);
export default __webpack_public_path__ + "static/media/logo-rplus.f32dee142e6da4c55dd1d84c80931247.svg";
export { ForwardRef as ReactComponent };